import { useField, observer } from '@formily/react';
import { Field } from '@formily/core';
import classNames from 'classnames';
import { LinkPosition, QuestionConfig } from '../../types/feelgood';
import styles from './style.module.less';

export default observer(() => {
  const field = useField<Field>();
  const { descriptionData } = field.data as QuestionConfig;
  return (
    <div
      className={styles.description}
      style={{
        color: descriptionData?.textColor,
      }}
    >
      {descriptionData?.linkPosition === LinkPosition.Begin && (
        <a
          className={classNames(styles.descriptionLink)}
          target="_blank"
          href={`https://${descriptionData?.linkUrl}`}
        >
          {descriptionData?.linkText}
        </a>
      )}
      {` ${descriptionData?.descText} `}
      {descriptionData?.linkPosition === LinkPosition.End && (
        <a
          className={classNames(styles.descriptionLink)}
          target="_blank"
          href={`https://${descriptionData?.linkUrl}`}
        >
          {descriptionData?.linkText}
        </a>
      )}
    </div>
  );
});
